<!--
  @负责人: xiehan
  @创建时间: 2019-01-03
  @版本:v2.0.0
  @描述: 流程角色管理
-->

<template>
  <div class="workFlowRoleManage">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-tree :data="treeList" :props="defaultProps" @node-click="handleNodeClick">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span v-show="data.children.length === 0">
              <el-button
                type="text"
                size="mini"
                v-g-rac="gRac('workFlowRoleManage@add')"
                @click.stop="() => addUser(data)">
                {{ $t('workFlowRoleManage.addUser') }}
              </el-button>
            </span>
          </span>
        </el-tree>
      </el-col>
      <el-col :span="16">
        <div class="rolelist__wrap">
          <div class="each-role" v-for="(item, index) in currentRoleList" :key="item.id">
            <span v-text="item.name"></span>
            <el-button
              class="btn__position"
              type="text"
              v-g-rac="gRac('workFlowRoleManage@delete')"
              @click="deleteRole(index)">
              {{ $t('common.delete') }}
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog :closeOnClickModal="false"
      :title="$t('workFlowRoleManage.addUser')"
      :visible.sync="addUserDiaVis"
      width="800px">
      <el-form ref="searchForm" :model="searchForm" :inline="true">
        <el-form-item :label="$t('workFlowRoleManage.userName')" input-width="auto">
          <el-input v-model="searchForm.userName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" 
            v-g-rac="gRac('releaseVersion_search')"
            @click="search"
            v-text="$t('common.search')"></el-button>
        </el-form-item>
      </el-form>
      <el-table-extend
        :data="tData" 
        :head="tHead" 
        :currentChange="tCurrentChange" 
        :sizeChange="tSizeChange" 
        :selection="true"
        :selectionChange="selectRole"
        border>
      </el-table-extend>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addUserDiaVis = false" v-text="$t('common.cancel')"></el-button>
        <el-button type="primary" @click="confirmAdd" v-text="$t('common.confirm')"></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import table from '@/components/mixins/table'
  import { extend } from '@/utils/tool'
  import workFlowRoleManageBiz from '@/logic/workFlow/workFlowRoleManageBiz'
  import userManageBiz from '@/logic/systemSetting/userManageBiz'
  export default {
    mixins: [rac, table],
    data () {
      return {
        treeList: [],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        selectId: null,
        addId: null,
        addUserDiaVis: false,
        searchForm: {
          userName: ''
        },
        selectRoleList: [],
        currentRoleList: []
      }
    },
    methods: {
      handleNodeClick (data) {
        this.selectId = data.id
        this.getRoleList(this.selectId)
      },
      getRoleList (id) {
        workFlowRoleManageBiz.findUsersByGroupId({
          groupId: id
        }).then(data => {
          if (data && data.length > 0) {
            this.currentRoleList = data
          } else {
            this.currentRoleList = []
          }
        })
      },
      addUser (data) {
        this.addId = data.id
        this.selectRoleList = []
        this.searchForm.userName = ''
        this.tResetPage()
        this.initTable()
        this.searchTable()
        this.addUserDiaVis = true
      },
      confirmAdd () {
        workFlowRoleManageBiz.addUserToRole({
          groupId: this.addId,
          userIds: this.selectRoleList.map(item => item.id)
        }).then(data => {
          this.successMessage()
          this.getRoleList(this.selectId)
          this.addUserDiaVis = false
        })
      },
      getGroups () {
        workFlowRoleManageBiz.getAllGroup().then(data => {
          let treeList = []
          data.map(item => {
            treeList.push({
              children: [],
              ...item
            })
          })
          treeList.map(item => {
            if (!item.parentId) {
              treeList.map(_item => {
                if (item.id === _item.parentId) item.children.push(_item)
              })
              this.treeList.push(item)
            }
          })
        })
      },
      initTable () {
        this.tInitTable({
          lanKey: 'userManage.table',
          head: ['userName', 'realName'],
          requestFun: this.searchTable
        })
      },
      search () {
        this.tResetPage()
        this.searchTable()
      },
      searchTable () {
        const reqData = extend(true, { ...this.tPageInfo }, this.searchForm)
        userManageBiz.findUser(reqData).then((data) => {
          this.tData = data
        })
      },
      selectRole (data) {
        this.selectRoleList = data
      },
      deleteRole (index) {
        this.$confirm(this.$t('common.deleteTips'), this.$t('common.delete'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          type: 'warning'
        }).then(() => {
          workFlowRoleManageBiz.deleteRole({
            groupId: this.selectId,
            userId: this.currentRoleList[index].id
          }).then(() => {
            this.successMessage()
            this.getRoleList(this.selectId)
          })
        }).catch(() => {})
      },
      successMessage () {
        this.$message({
          message: this.$t('common.success'),
          type: 'success'
        })
      }
    },
    mounted () {
      this.getGroups()
    }
  }
</script>

<style scoped>
  .rolelist__wrap {
    padding: 24px 10px;
    height: 400px;
    width: 230px;
    overflow-y: scroll;
  }
  .each-role {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    align-items: baseline;
    font-size: 14px;
  }
  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
</style>